// extracted by mini-css-extract-plugin
export var button = "_nc-0";